import type { FC } from 'react';
import AntCheckbox from 'antd/es/checkbox';
import type {
  CheckboxProps as AntCheckboxProps,
  CheckboxGroupProps as AntCheckboxGroupProps,
} from 'antd/es/checkbox';
import { cn } from 'app/lib/utils';

export interface CheckboxProps extends AntCheckboxProps {}

export interface CheckboxGroupProps extends AntCheckboxGroupProps {
  /** Highlights the group with an error border */
  error?: boolean;
}

const CheckboxBase: FC<CheckboxProps> = (props) => <AntCheckbox {...props} />;

const Group: FC<CheckboxGroupProps> = ({ error, className, ...rest }) => (
  <AntCheckbox.Group
    className={cn(error && 'border border-red-500 rounded p-2', className)}
    {...rest}
  />
);

/**
 * Checkbox façade over antd `Checkbox`; `Group` accepts a semantic `error` prop.
 */
export const Checkbox = CheckboxBase as typeof CheckboxBase & {
  Group: typeof Group;
};
Checkbox.Group = Group;

export default Checkbox;
